(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('hw-sticky');
    var heroAction = document.getElementById('hero-reserve-action');
    var reserve = document.getElementById('reserve');
    if (!bar || !heroAction || !reserve) return;
    var heroActionVisible = true;
    var reserveVisible = false;
    function updateBar() {
      var visible = !heroActionVisible && !reserveVisible;
      bar.classList.toggle('hw-sticky--visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
    var heroObserver = new IntersectionObserver(function (entries) {
      heroActionVisible = entries[0].isIntersecting;
      updateBar();
    }, { threshold: 0 });
    var reserveObserver = new IntersectionObserver(function (entries) {
      reserveVisible = entries[0].isIntersecting;
      updateBar();
    }, { threshold: 0.1 });
    heroObserver.observe(heroAction);
    reserveObserver.observe(reserve);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-sunrise-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.hw-sunrise');
    if (!section) return;

    var scenes = section.querySelectorAll('.hw-sunrise__scene');
    var dots   = section.querySelectorAll('.hw-sunrise__dot');
    var btnPrev = section.querySelector('.hw-sunrise__btn--prev');
    var btnNext = section.querySelector('.hw-sunrise__btn--next');
    var btnPlay = section.querySelector('.hw-sunrise__btn--play');
    var current = 0;
    var timer   = null;

    function go(index) {
      scenes[current].classList.remove('hw-sunrise__scene--active');
      dots[current].classList.remove('hw-sunrise__dot--active');
      current = (index + scenes.length) % scenes.length;
      scenes[current].classList.add('hw-sunrise__scene--active');
      dots[current].classList.add('hw-sunrise__dot--active');
    }

    function startAuto() {
      stopAuto();
      btnPlay.textContent = 'Pause';
      timer = setInterval(function () {
        if (current === scenes.length - 1) { stopAuto(); return; }
        go(current + 1);
      }, 2200);
    }

    function stopAuto() {
      clearInterval(timer);
      timer = null;
      btnPlay.textContent = 'Preview the sunrise';
    }

    btnPrev.addEventListener('click', function () { stopAuto(); go(current - 1); });
    btnNext.addEventListener('click', function () { stopAuto(); go(current + 1); });
    btnPlay.addEventListener('click', function () {
      if (timer) { stopAuto(); }
      else { if (current === scenes.length - 1) go(0); startAuto(); }
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { stopAuto(); go(i); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
